import { useCallback } from "react";
import { MdEditor, ToolbarNames } from "md-editor-rt";

import { Flex } from "@chakra-ui/react";

import "md-editor-rt/lib/style.css";

const MAX_TEXT_LENGTH = 25_000;

const TOOLBARS_ITEM_EXCLUDED = [
  "code",
  "code-block",
  "html-preview",
  "preview",
  "mermaid",
  "katex",
  "image",
  "table",
  "-",
  "revoke",
  "next",
  "save",
  "codeRow",
  "code",
  "=",
  "pageFullscreen",
  "fullscreen",
  "preview",
  "htmlPreview",
  "catalog",
  "github",
  "prettier",
];

export type MarkdownEditorProps = {
  value: string;
  setValue: (value: string) => void;
  onChange?: (value: string) => void;
};

export default function MarkdownEditor({
  value,
  setValue,
  onChange,
}: MarkdownEditorProps) {
  const trimToMaxLength = useCallback((text: string) => {
    return text.substring(0, MAX_TEXT_LENGTH);
  }, []);

  const handleOnChange = useCallback(
    (newValue: string) => {
      const trimmedNewValue = trimToMaxLength(newValue);
      onChange?.(trimmedNewValue);
      setValue(trimmedNewValue);
    },
    [onChange, setValue, trimToMaxLength]
  );

  return (
    <Flex mt={4}>
      <MdEditor
        theme="dark"
        modelValue={value}
        preview={false}
        onChange={handleOnChange}
        toolbarsExclude={TOOLBARS_ITEM_EXCLUDED as ToolbarNames[]}
        noMermaid
        language="en-US"
      />
    </Flex>
  );
}
